import type { GetProfilesRequestProps } from '@services/api/accessProfile/types'
import type { GetProfilesFormDataProps } from '../context/types'

export const parseGetProfilesPaylod = (formData: GetProfilesFormDataProps) => {
  const payload: GetProfilesRequestProps = {
    bodyParams: {
      currentPage: formData.page!,
      itemsPerPage: formData.itemsPerPage!,
      sortBy: formData.sortType ? formData.sortBy! : null,
      sortType: formData.sortType || null,
      profileDescriptionFilter: formData.profileDescription ? [formData.profileDescription] : null,
      profileTypeFilter: formData.profileType ? [formData.profileType] : null,
      status: formData.status ? [formData.status] : null,
      profileIdFilter: formData.userId ? formData.userId.toString() : null
    }
  }

  return payload
}
